import {ebus} from '@/vendor/ebus';

// export const walletEnvironment = 'TEST';
export const walletEnvironment =  'PRODUCTION';

// https://test.saferpay.com/BO/Settings/FieldsAccessToken
export const accessToken = 'b317fd20-a0cf-471b-b56c-fe37db3800dc'
// export const accessToken = 'af1f890f-a8e2-4aeb-94ef-ad674879d1cd'; //for vtest39: af1f890f-a8e2-4aeb-94ef-ad674879d1cd
export const customerId = '653796'; // from backoffice loginname deck: 653796

export const googleGateway = 'worldlinesaferpay';
export const googleGatewayMerchantId = '17761156'; // the terminalId from the backoffice deck: 17761156

//merchantId can be found on https://pay.google.com/business/console/
export const googlePayMerchantId = 'BCR2DN4T7XZLXPYV';

// work in progress
